// AI Generated Test
import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { ChangesHistoryReadabilityService } from '@client/app/pages/global/changes-history/services/readability/readability.service';

@Component({
    selector: 'changes-history-dashboard-summary-readability',
    standalone: false,
    template: `
        <div class="ml-4">
            <div class="outer-b-smurf font-size-1-1 font-weight-500" translate>
                Most common readability level
            </div>
            <div class="outer-t-smurf mb-1 font-size-175 font-weight-500">
                <span class="mr-1 fas fa-square font-size-1-3" [ngStyle]="{color: mostCommonLevel.color}"></span><span>{{ mostCommonLevel.label }}</span>
            </div>
            <span class="mt-0">
                @let formattedPercentage = mostCommonLevel.percentage | monNumber:'0.[00]%';
                <span class="text-grey">
                    {{ '[[percentage]] of pages' | translate:'': {percentage: formattedPercentage} }}
                </span>
            </span>
        </div>
    `,
})
export class ReadabilityComponent implements OnInit, OnChanges {
    @Input() history: any;
    @Input() domain: any;
    @Input() total: any;

    mostCommonLevel: any = {};

    constructor (
        private changesHistoryReadabilityService: ChangesHistoryReadabilityService,
    ) {}

    ngOnInit () {
        this.total = this.total || 0;
        this.setDefaultMostCommonLevel();
        this.setMostCommonLevel();
    }

    ngOnChanges () {
        this.total = this.total || 0;
        this.setDefaultMostCommonLevel();
        this.setMostCommonLevel();
    }

    private setMostCommonLevel () {
        if (!this.history || this.history.length === 0 || !this.domain) {
            return;
        }
        const latestEntry = this.history[this.history.length - 1];
        this.mostCommonLevel = this.changesHistoryReadabilityService.getMostCommonReadabilityLevel(
            this.domain.features.readability_test,
            latestEntry.readability_distribution,
        );

        if (this.mostCommonLevel && this.total > 0) {
            this.mostCommonLevel.percentage =
                latestEntry.readability_distribution[this.mostCommonLevel.attr] / this.total;
        } else {
            this.setDefaultMostCommonLevel();
        }
    }

    private setDefaultMostCommonLevel () {
        this.mostCommonLevel = {
            percentage: 0,
        };
    }
}
